export const SIDEBAR_DETAIL_KEYS = {
  COURSE_NUMBER: 'course-number',
  ORGANIZATION: 'organization',
  START_DATE: 'start-date',
  END_DATE: 'end-date',
  EFFORT: 'effort',
  LANGUAGE: 'language',
  PACING: 'pacing',
  REQUIREMENTS: 'requirements',
} as const;
